import React from 'react';

const colors = ['#a6cee3', '#1f78b4']; // From ColorBrewer

const BooleanStyle = props => {
    return <div>BooleanStyle</div>;
};

export default BooleanStyle;



// WEBPACK FOOTER //
// ./src/components/dataItem/BooleanStyle.js